import { Component, computed, inject, input } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { AdditionalInfo, AdditionalInfoValidation } from '../../models/classes/additionalinfo';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-list-hint-validation',
  imports: [NzIconModule],
  templateUrl: './list-hint-validation.html',
  styleUrls: ['./list-hint-validation.scss'],
})
export class ValidationHintsComponent {
  // Parent passes the current item and a validator function
  item = input.required<AdditionalInfo>();
  resolveIsValid =
    input.required<(item: AdditionalInfo, rule: AdditionalInfoValidation) => boolean>();

  public i18n = inject(I18nService);

  // Convenience computed signals
  showValidation = computed<boolean>(() => !!this.item().showValidation);
  validations = computed<AdditionalInfoValidation[] | undefined>(() => this.item().validations);
  defaultValidation = computed<AdditionalInfoValidation[] | undefined>(
    () => this.item().defaultValidation
  );

  // We consider default (grey) hints visible when NOT showing validations explicitly
  showDefaultGrey = computed<boolean>(() => {
    const v = this.validations();
    const show = this.showValidation();
    return !(v && show);
  });
}
